function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.7 283.7"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M273.8 160.9l-35.3-54.1-22 6.3 8.2-44.8-83.1-60.9-82.2 61 8 44.9-22.4-6.5-35.4 54.1L66 255.2l36.2 5.8 39.1 22.5 39.3-22.4 36.7-5.9 56.5-94.3zm-230.6.6L57.3 140l15.6 4.5L88 229.8l-4.3-.7-40.5-67.6zm84.6 81.3l-9.4-5.4-23.1-130 32.5 23.9v111.5zm-29-168.2l42.9-31.8 43.5 31.9-42.9 31.8-43.5-31.9zm57.5 167.6V131.7l32.2-23.9-23.7 129.5-8.5 4.9zm38.9-12.3l15.6-85.4 15.4-4.4 14.1 21.5-40.5 67.6-4.6.7z"
})));